import { Area } from './area';
import { NumberFormat } from './numberFormat';

// The 'rangeIndeps' object stores dependencies based on range addresses, which contain ':' between cell addresses, such as 'A1:B1', 'B:B', '3:3', etc.
// For single cell addresses, you can directly access them via 'cellReferences[0][0].i' to retrieve an array of dependencies.
// For range addresses, we utilize 'rangeIndepsMatrix' to efficiently manage dependencies.
// 'rangeIndepsMatrix' indexes column-wise, containing arrays of addresses falling under each column of the ranges.
// To find dependencies for a range, we first search for them using column indexes in 'rangeIndepsMatrix', then iterate over the corresponding arrays to process the dependencies.
// We are not using Array-Address(`1,2,3,4`) because independent addresses will not be increased on row or column increase. For example, in case of B1:B100, it will always be B1:B100, and in case of B:B, we have to check real-time for the maximum rows/columns.

export interface SheetReferences {
  dynamicFormulas: DynamicFormula[];

  cellsReferences: CellsReferences;
  // dependencies: ColumnDependencies;

  rangeIndepsMatrix: RangeIndepsMatrix, // Stores column-wise indexes of independent addresses to expedite dependency calculations.
  rangeIndeps: RangeIndependencies; // Object containing dependencies based on cell addresses.
}

export type CellsReferences = CellReference[][];

export type RangeIndepsMatrix = string[][];

export type CellReference = Partial<ReferenceInterface>;

export interface ReferenceInterface {
  d: Dependency[]; // Dependency
  i: Independency[]; // Independeny
  // nf: NumberFormat; // Number Format
  // s: StyleFormat.Style; // Styles
}

export interface RangeIndependencies {
  [address: string]: Independency[];
}

export interface Dependency {
  sid: string; // Sheet Id
  addr: string; // Address | OR | id of CF, DV, DF in case of Independency
}

export interface ColumnDependencies {
  [colIndex: string]: RowDependencies;
}

export interface RowDependencies {
  [rowIndex: string]: Dependency[];
}

export interface Independency extends Dependency {
  type: ReferenceType;
}

export interface CellIndependencies {
  [arrayAddress: string]: Independency[];
}

interface DynamicFormula {
  id: string;
  formula: string;
  indepArea: Area;
  depArea: Area;
}

export enum ReferenceType {
  DataValidation,
  ConditionalFormat, // Will be used for Data Bar Min Max
  CellFormula,
  DynamicFormula, // Will calculate the relative/absolute formula accordingly
}
